import {gql} from "@apollo/client";

export const GET_ORGANIZATIONS = gql`
    query MyOrgs($profileId: Int!, $page: Int!, $pageSize: Int, $includeWaivers: Boolean!, $includeVenues: Boolean!, $includeSanctions: Boolean!) {
        organizations(profileId: $profileId, page: $page, pageSize: $pageSize){
            objects {
                id
                slug
                name
                organizationType {
                    code
                }
                activeSubscription {

                    plan {
                        id
                        name
                        features {
                            key
                        }
                    }
                }
                divisionsCount
                logoUrl
                address
                id
                currency
                waivers {
                    id
                    title
                }
                fields{
                    id
                    name
                    description
                }
                sanctionRule{
                    id
                    name
                }
                stripeAccount{
                    id
                    name
                }
                youtubeProvider {
                    id
                    name
                    streamingAccountId
                }
                branding {
                    subdomain
                    primaryColor
                    secondaryColor
                    accentColor
                    backgroundColor
                    surfaceColor
                    borderColor
                    textOnBackground
                    textOnSurface
                    textOnPrimary
                    textOnSecondary
                    logoUrl
                }
            }
            page
            pages
            ownedOrganizationCount
            ownedOrganizationLimit
            hasNext
            hasPrev
       }
        waivers(page: 1, pageSize: 100) @include(if: $includeWaivers) {
            objects {
                id
                title
                waiverType
                documentUrl
                content
                createdBy {
                    email
                }
            }
        }

        venues(page: 1, pageSize: 100) @include(if: $includeVenues) {
            objects {
                id
                name
                fields {
                    id
                    name
                }
                createdBy {
                    email
                }
            }
        }

        sanctionRules(page: 1, pageSize: 100) @include(if: $includeSanctions) {
            objects {
                id
                name
            }
        }

        stripeAccounts {
            id
            name
        }
    }
`;

export const FLAT_ORGANIZATIONS = gql`
    query FlatOrganizations($profileId: Int!, $page: Int, $pageSize: Int) {
        organizations(profileId: $profileId, page: $page, pageSize: $pageSize) {
            objects {
                logoUrl
                slug
                name
                divisions{
                    id
                    name
                    seasons{
                        id
                        name
                        teams{
                            team{
                                id
                                name
                                logoUrl
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const GET_ORGANIZATION_DIVISION_SUMMARY = gql`
    query OrganizationDivisionSummary($organizationSlug: String!) {
        organizationDivisionSummary(
            organizationSlug: $organizationSlug
        ) {
            totalDivisions
            openDivisions
            activeSeasons

            totalTeams
            totalPlayers

            totalGames
            completedGames
            scheduledGames
            cancelledGames

            teamsByDivision {
                divisionId
                divisionName
                count
            }

            playersByDivision {
                divisionId
                divisionName
                count
            }

            gamesByStatus {
                status
                count
            }
        }
    }
`;
